import { includes, last } from "lodash";
import { CalendarMode, CalendarView } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { Row } from "PFApp/booking/types/row";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import { WorkforceItem } from "PFCore/hooks/queries/bookings/workforce/use_workforce_entries";
import { Profile } from "PFCore/hooks/queries/profile";

import { getOriginalResource } from "../../../helpers";
import { AllBookingsModeRowsStateType } from "./booking_rows_context";

export const isRowContainingBookings = (
  { type }: Row,
  heatMapEnabled: boolean,
  calendarMode: CalendarMode,
  view: CalendarView
) => {
  if (calendarMode === CalendarMode.Projects) {
    return type === RowType.Profile;
  } else {
    return (
      type !== RowType.Profile ||
      (!heatMapEnabled && !includes([CalendarView.Utilization, CalendarView.Availability], view))
    );
  }
};

export const mapToProfileWithActivityId = (
  row: Row,
  rowsByKey: Record<string, Row>,
  calendarMode: CalendarMode,
  allBookingsModeRowsState: AllBookingsModeRowsStateType
): Profile => {
  const { key, type, parents } = row;
  const closestParentKey = last(parents);
  const parentRow = closestParentKey ? rowsByKey[closestParentKey] : null;
  const originalResourceId = getOriginalResource(row, calendarMode)?.id;
  if (calendarMode === CalendarMode.Projects) {
    const isAllBookingsModeEnabledForParent =
      !!closestParentKey && allBookingsModeRowsState[closestParentKey];
    return {
      id: originalResourceId!,
      rowKey: key,
      ...(isAllBookingsModeEnabledForParent
        ? {}
        : { activityId: (parentRow?.original as ProjectItem).activity.id })
    };
  } else {
    if (type === RowType.Profile) {
      return { id: originalResourceId!, rowKey: key };
    } else {
      return {
        id: (parentRow?.original as WorkforceItem).profile.id,
        rowKey: key,
        activityId: originalResourceId ?? false
      };
    }
  }
};
